import { render, staticRenderFns } from "./Gallery3.vue?vue&type=template&id=2055a469&"
import script from "./Gallery3.vue?vue&type=script&lang=js&"
export * from "./Gallery3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports